<template>
  <div class="chapter-progress mt-n6">
    <a @click="$events.emit('set-project-contents-open', { from: $route })">
      <v-progress-circular
        class="d-inline-block ml-8"
        :rotate="-90"
        :size="30"
        :value="progress"
        width="1.5"
        color="#db0812"
      >
        <div class="white-circle"></div>
      </v-progress-circular>
      <span class="d-block ml-n2 mt-1 text-center" v-translate>Chapter Contents</span>
    </a>
  </div>
</template>

<script>
import find from 'lodash/find'

export default {
  name: 'ChapterProgress',

  mounted () {
  },

  computed: {
    progress () {
      return parseFloat(this.$root.chapterProgress).toFixed(2)
    },

    countProjects () {
      const chapter = find(this.$root.chapters, { _slug: 'chapter-' + this.$route.params.chapterId })

      return (!chapter) ? 0 : chapter[this.$route.params.language].projects.length + 2
    }
  }
}
</script>

<style scoped lang="scss">

.chapter-progress {
  max-width: 100px;
}

span {
  margin-left: 10px;
  line-height: 1;
}

.white-circle {
  width: 10px;
  height: 10px;
  background-color: $c-light-grey;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  margin: auto;
  left: 0;
  right: 0;
}

a {
  pointer-events: all;

  &:hover {
    span {
      color: $c-red;
    }
  }
}

</style>
